import {
  equalTo,
  get,
  orderByChild,
  push,
  query,
  ref,
  set,
} from "firebase/database";
import { database } from "../App";

export const getClient = async (plate = "10MZ999", phone) => {
  let data = null;
  if (!plate.startsWith("+374")) {
    const dbRef = ref(database, "ClientsData");
    const myQuery = query(dbRef, orderByChild("plate"), equalTo(plate));

    await get(myQuery).then((snap) => {
      data = Object.values(snap.val())[0];
    });
  } else {
    const dbRef = ref(database, `ClientsData/${plate}`);
    await get(dbRef).then((snap) => {
      data = snap.val();
    });
  }
  return data;
};
export const addNotification = (mess) => {
  const dbRef = ref(database, "AdminMessages");
  push(dbRef, { date: new Date().toString(), message: mess }).then((resp) => {
    console.log(resp);
  });
};

export const editClient = (client) => {
  const dbRef = ref(database, `ClientsData/${client.phone}`);
  set(dbRef, client).then((resp) => {
    console.log(resp);
  });
};
export const deleteClient = (client) => {
  const dbRef = ref(database, `ClientsData/${client.phone}`);
  set(dbRef, null).then((resp) => {
    console.log(resp);
  });
};

export const getBalances = async () => {
  const dbRef = ref(database, `ClientsPaymentLog`);
  let data = null;
  await get(dbRef).then((snap) => {
    data = Object.keys(snap.val()).map((key) => {
      return {
        key: key,
        value: snap.val()[key],
      };
    });
  });
  return data;
};
export const getPredefine = async () => {
  const dbRef = ref(database, `PreDefinedMessages`);
  let data = null;
  await get(dbRef).then((snap) => {
    data = snap.val();
  });
  return data;
};
export const setNewMessages = async (data) => {
  const dbRef = ref(database, `PreDefinedMessages`);
  set(dbRef, data);
};
export const getPetrolPrices = async (cb) => {
  const dbRef = ref(database, `PetrolPrices`);

  await get(dbRef).then((snap) => {
    if (snap.exists()) cb(snap.val());
  });
};
export const setPetrolPrices = async (data) => {
  const dbRef = ref(database, `PetrolPrices`);
  set(dbRef, data);
};
